import { render, staticRenderFns } from "./CourseMaterial.vue?vue&type=template&id=fa671c7e&scoped=true&"
import script from "./CourseMaterial.vue?vue&type=script&lang=js&"
export * from "./CourseMaterial.vue?vue&type=script&lang=js&"
import style0 from "./CourseMaterial.vue?vue&type=style&index=0&id=fa671c7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa671c7e",
  null
  
)

export default component.exports